import { apiClient } from "@/API/axiosClient";
import { questions_urls } from "@/API/config";
import store from "@/store/store";

export async function unassignQuestionFromModuleUseCase(questionId) {
  const response = await apiClient.put(questions_urls.update(questionId), {
    Modules: null,
    DAT_LastEdited: new Date().toISOString(),
    TXT_LastEditedBy: store.state.auth.id,
  });

  
  if (response.status !== 202) {
    throw new Error(
      `Désaffectation refusée (${response.status}): ${JSON.stringify(response.data)}`
    );
  }

  return response.data;
}
